export default __webpack_public_path__ + "img/Poppins-Bold_13c17db.ttf";